export default "__VITE_ASSET__BayWqou2__"